import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import Students from "./student/Students";
import ArchiveStudent from "./student/ArchiveStudent";
import OlympiadStudent from "./student/OlympiadStudent";

const StudentTab = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="content-wrapper">
      <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
        <div className="container-fluid">
          <h4 className="m-0">Students</h4>
        </div>
      </div>

      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}>
        <Tabs value={tabValue} onChange={handleChange}>
          <Tab label="Student" />
          <Tab label="Archived Student" />
          <Tab label="Olympiad Student" />
        </Tabs>
      </Box>

      <Box sx={{ p: 2 }}>
        {tabValue === 0 && <Students />}
        {tabValue === 1 && <ArchiveStudent />}
        {tabValue === 2 && <OlympiadStudent />}
      </Box>
    </div>
  );
};

export default StudentTab;
